import LocationsSelector from '$src/components/LocationsSelector/';
import useStores from '$src/hooks/useStores';
import { redirectToOnboardingIntroduction } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';

export default function Location() {
  const {
    locationStore: { locations, fetchLocations, hasError },
    sessionStore: { user, isMobile },
  } = useStores();

  if (hasError) {
    handleBackToRingDashboard(isMobile);
    return null;
  }

  const handleClick = ({ locationId }) => {
    redirectToOnboardingIntroduction(locationId);
  };

  if (user && locations === null) fetchLocations(user?.user_id);

  return <LocationsSelector handleClick={handleClick} />;
}
